import { z } from 'zod';

import { StatsWindowSchema } from '../../stats/stats-range/stats-range';
import { BreakdownRowSchema, ComparableCountSchema } from '../../stats/stats-shapes/stats-shapes';

/** One bucket of the likes-vs-passes chart. */
export const LikeDecisionPointSchema = z
  .object({
    bucket: z.string(),
    like: z.number().int().nonnegative(),
    pass: z.number().int().nonnegative(),
  })
  .strict();

export type LikeDecisionPoint = z.infer<typeof LikeDecisionPointSchema>;

/** One bucket of the matches-created chart. */
export const MatchCreatedPointSchema = z
  .object({
    bucket: z.string(),
    count: z.number().int().nonnegative(),
  })
  .strict();

export type MatchCreatedPoint = z.infer<typeof MatchCreatedPointSchema>;

/** The Dashboard's Engagement section, matching half (D12). */
export const MatchingStatsSchema = z
  .object({
    window: StatsWindowSchema,
    likes: ComparableCountSchema,
    likeRate: z.number().min(0).max(1),
    matchesCreated: ComparableCountSchema,
    activeMatches: z.number().int().nonnegative(),
    matchesEndedByReason: z.array(BreakdownRowSchema),
    likesPerBucket: z.array(LikeDecisionPointSchema),
    matchesPerBucket: z.array(MatchCreatedPointSchema),
  })
  .strict();

export type MatchingStats = z.infer<typeof MatchingStatsSchema>;
